import * as React from 'react';
import { NavPath } from '../../paths';
import { Switch, Route } from 'react-router';
import { LogoHeading } from '../shared/LogoHeading';
import { NavLink } from 'react-router-dom';

export interface PageHeaderProps {
}

export const PageHeader = (props: PageHeaderProps) => {


    return <div className="page-header">
        <Switch>
            <Route path={NavPath.who} exact>
                <LogoHeading subHeading="Who are you and what are you doing?" />
            </Route>
            <Route path={NavPath.what} exact >
                <LogoHeading subHeading="What are you spending?" />
            </Route>
            <Route path={NavPath.breakdown} exact>
                <LogoHeading subHeading="This is what you need to break even" />
            </Route>
            <Route path={NavPath.outcomes} exact>
                <LogoHeading subHeading="Other Potential Outcomes" />
            </Route>
        </Switch>
    </div>

}